import classNames from 'classnames';
import {
  FlexContainer,
  PartialWidthContainer,
  Txt,
  IconBlock,
  UserPayments,
} from 'components';
import { DateTime } from 'luxon';
import { Helmet } from 'react-helmet';
import { Outlet, useNavigate } from 'react-router-dom';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { usePayments, usePublicAccount } from 'state';
import { withInitialization } from 'hoc';
import combineHOCs from 'lib/combineHOCs';
import styles from './PaymentsHomeScreen.module.scss';

/**
 * PaymentsHomeScreen
 *
 * @return {JSX.Element}
 */
const PaymentsHomeScreen = ({ className }) => {
  const navigate = useNavigate();
  const publicAccount = usePublicAccount();
  const { data: dataState } = publicAccount;

  const bankingHasLinked = !!dataState.banking?.plaidRecipientId;

  // const handleTransactionClick = (transactionId) =>
  //   navigate(`transaction/${transactionId}`);
  const handleEditBankAccount = () => navigate('bank');

  return (
    <PartialWidthContainer
      className={classNames(
        styles.PaymentsHomeScreen,
        className,
        `${PaymentsHomeScreen.displayName}`
      )}
      column
      gap
      small
    >
      <Helmet title="Banking" />
      <FlexContainer column gap>
        <FlexContainer column gapHalf>
          <Txt xx>Payments to</Txt>
          <IconBlock icon="bank" gapHalf onClick={handleEditBankAccount}>
            <Txt xx>
              {bankingHasLinked
                ? dataState.banking.accountName
                : 'Link a bank account'}
            </Txt>
            <Txt>
              Account ending -{' '}
              {dataState.banking.accountMask || (
                <Txt regular italic>
                  XXXX
                </Txt>
              )}
            </Txt>
            {bankingHasLinked ? (
              <Txt>
                Linked -{' '}
                {DateTime.fromJSDate(
                  fromSwiftDate(dataState.banking.dateUpdated)
                ).toLocaleString(DateTime.DATE_MED)}
              </Txt>
            ) : null}
            <Txt m>{bankingHasLinked ? 'Tap to edit' : 'Tap to link'}</Txt>
          </IconBlock>
        </FlexContainer>
        <FlexContainer column gapHalf>
          <Txt xx>Your payments</Txt>
          <UserPayments />
        </FlexContainer>
      </FlexContainer>
      <Outlet />
    </PartialWidthContainer>
  );
};

PaymentsHomeScreen.displayName = 'PaymentsHomeScreen';

export default combineHOCs(withInitialization(usePayments))(PaymentsHomeScreen);
